// ck-list-engine.js

const CK_WORKER_URL = "https://ck-shopping-list.adam-dcd.workers.dev";

// --- 1. ID MANAGEMENT ---
function ckGetListId() {
  // Try to get a logged-in Shopify Customer ID (we will inject this via Liquid later)
  const customerId = window.ckCustomerId || null;
  
  if (customerId) {
    return `customer_${customerId}`;
  }

  // Fallback to Guest ID
  let guestId = localStorage.getItem('ck_guest_list_id');
  if (!guestId) {
    guestId = 'guest_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('ck_guest_list_id', guestId);
  }
  return guestId;
}

// --- 2. CLOUD SYNCING ---
async function ckFetchCloudList() {
  const listId = ckGetListId();
  try {
    const response = await fetch(`${CK_WORKER_URL}?list_id=${listId}`);
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Cook & Keeper: Error fetching list from cloud", error);
    return {}; // Return empty object on failure so the UI doesn't crash
  }
}

async function ckSaveCloudList(listData) {
  const listId = ckGetListId();
  try {
    const response = await fetch(`${CK_WORKER_URL}?list_id=${listId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(listData)
    });
    const result = await response.json();
    
    // Dispatch a custom event so other open tabs can update their UI counters instantly
    window.dispatchEvent(new CustomEvent('ck_list_updated', { detail: listData }));
    return result.success;
  } catch (error) {
    console.error("Cook & Keeper: Error saving list to cloud", error);
    return false;
  }
}

// --- 3. UNIVERSAL CONVERSION ENGINE ---
// Standardizes everything to base metric units (g, ml, pcs) for math, 
// then allows formatting back to user preferences.
function ckConvertUnits(qty, fromUnit, toUnit) {
  let baseQty = parseFloat(qty);
  if (isNaN(baseQty)) return 0;

  const unitMap = {
    'kg': { type: 'weight', factor: 1000 },
    'g': { type: 'weight', factor: 1 },
    'oz': { type: 'weight', factor: 28.3495 },
    'lbs': { type: 'weight', factor: 453.592 },
    'l': { type: 'volume', factor: 1000 },
    'ml': { type: 'volume', factor: 1 },
    'fl oz': { type: 'volume', factor: 29.5735 },
    'cups': { type: 'volume', factor: 240 },
    'pcs': { type: 'count', factor: 1 }
  };

  const fUnit = fromUnit.toLowerCase().trim();
  const tUnit = toUnit.toLowerCase().trim();

  // If units are identical or unmapped, return original
  if (fUnit === tUnit || !unitMap[fUnit] || !unitMap[tUnit]) return baseQty;
  
  // Prevent converting weight to volume
  if (unitMap[fUnit].type !== unitMap[tUnit].type) {
    console.warn(`Cook & Keeper: Cannot convert ${fUnit} to ${tUnit}`);
    return baseQty; 
  }

  // Convert to base metric (g or ml), then to target unit
  const inBase = baseQty * unitMap[fUnit].factor;
  const finalQty = inBase / unitMap[tUnit].factor;

  return Number(finalQty.toFixed(2));
}

// --- 4. ADD TO LIST LOGIC ---
async function ckAddToList(handle, name, unit, sourceLabel, qtyRequired, qtyToBuy) {
  const currentList = await ckFetchCloudList();
  
  // Standardize the unit to lower case for database consistency
  const safeUnit = unit.toLowerCase().trim();

  if (!currentList[handle]) {
    currentList[handle] = {
      name: name,
      unit: safeUnit,
      sources: []
    };
  }

  // Check if this specific source (e.g. "Pasztecik") already exists for this ingredient
  const existingSourceIndex = currentList[handle].sources.findIndex(s => s.label === sourceLabel);

  if (existingSourceIndex > -1) {
    // Update existing entry
    currentList[handle].sources[existingSourceIndex].qty_required = qtyRequired;
    currentList[handle].sources[existingSourceIndex].qty_to_buy = qtyToBuy;
  } else {
    // Push new entry
    currentList[handle].sources.push({
      label: sourceLabel,
      qty_required: qtyRequired,
      qty_to_buy: qtyToBuy
    });
  }

  const success = await ckSaveCloudList(currentList);
  return success;
}